var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
let LoadingSpinnerComponent = class LoadingSpinnerComponent extends LitElement {
    render() {
        return html `<div class="spinner"></div>`;
    }
};
LoadingSpinnerComponent.styles = css `
        :host {
        }

        .spinner {
            aspect-ratio: 1 / 1;
            max-width: 100%;
            max-height: 100%;
            border: 5px solid #f3f3f3;
            border-top: 5px solid #3498db;
            border-radius: 50%;
            animation: spin 1s linear infinite;
        }

        @keyframes spin {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }
    `;
LoadingSpinnerComponent = __decorate([
    customElement('loading-spinner')
], LoadingSpinnerComponent);
export { LoadingSpinnerComponent };
